import * as React from "react";
import { Stack, Text, Link } from "@fluentui/react";

const LegacyWebViewMessage: React.FC = () => {
  return (
    <Stack tokens={{ childrenGap: 20 }} style={{ padding: "24px", textAlign: "center", fontFamily: "Segoe UI" }}>
      <Text variant="xLargePlus" styles={{ root: { fontWeight: 600 } }}>
        Deine Outlook-Version wird nicht unterstützt
      </Text>

      <Text variant="mediumPlus">
        Dein Outlook nutzt leider eine ältere Technologie (WebView1), die von diesem Add-In nicht unterstützt wird.
      </Text>

      <Text variant="mediumPlus" styles={{ root: { marginTop: "12px", fontWeight: 500 } }}>
        Was du tun kannst:
      </Text>

      <Stack tokens={{ childrenGap: 8 }}>
        <Text><b>➤ Nutze Outlook im Web:</b> Du kannst Outlook einfach in deinem Browser verwenden.</Text>
        <Text><b>➤ Wechsle zu einer neueren Outlook-Version:</b> Am besten aktualisierst du auf eine moderne Outlook-Version, die in Microsoft 365 enthalten ist. Diese unterstützt die neuere und benötigte Technologie WebView2. Falls WebView2 noch nicht auf deinem System installiert ist, kannst du es direkt von der offiziellen Microsoft-Webseite herunterladen.</Text>
      </Stack>
    </Stack>
  );
};

export default LegacyWebViewMessage;
